import { createContext } from 'react';

interface PatientContextProviderValue {
  tabIndex: number;
  triggerTabChange: boolean;
  handleTriggerTabChange: (newValue: number) => void;
  handleClearTrigger: () => void;
  setIsFormValid: (value: boolean) => void;
  setTriggerTabChange: (value: boolean) => void;
}

export const PatientContext = createContext<PatientContextProviderValue>({
  tabIndex: 0,
  triggerTabChange: false,
  handleTriggerTabChange: () => undefined,
  setIsFormValid: () => undefined,
  setTriggerTabChange: () => undefined,
  handleClearTrigger: () => undefined,
});
